import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import Banner3 from "../../assets/images/dasboard/banner3.png";
import Drawer from "react-modern-drawer";
import GymView from "../Sidebar/GymView";
import { useDispatch, useSelector } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { GET_MEAL_RECOMMENDATION_ENDPOINT } from "../../config/ApisCollection";
import { useNavigate, useParams } from "react-router-dom";
import MealView from "../Sidebar/MealView";

const MealCategory = () => {
  const [isDrawerPopupOpen, setDrawerPopupOpen] = useState(false);
  const [mealChoosedData, setmealChoosedData] = useState(null);
  const [meal_data, set_meal_data] = useState([]);
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const { type, category } = useParams();
  let history = useNavigate();

  const getExploreData = async () => {
    const currentDate = new Date();
    let api_url = `${GET_MEAL_RECOMMENDATION_ENDPOINT}/${category}`;
    if (category === "explore") {
      api_url = `${GET_MEAL_RECOMMENDATION_ENDPOINT}`;
    }
    const post_header = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };
    try {
      await axios.get(api_url, post_header).then((response) => {
        set_meal_data(Object.entries(response.data));
      });
    } catch (error) {}
  };

  useEffect(() => {
    if (category === "explore") {
      getExploreData();
    } else {
      getExploreData();
      // getGoodReadData();
    }
  }, []);

  // console.log(meal_data);

  return (
    <>
      <MainBg>
        <div className="grid xl:grid-cols-3 md:grid-cols-2 lg:grid-cols-3 grid-cols-1 sm:gap-2 py-20 mb-20">
          <div className="col-span-2 lg:px-10 px-2 sm:border-r-2 border-none mb-5">
            {/* <div className="">
              <input
                type="text"
                className="w-full border-2 border-gray-350 p-2 rounded-lg"
                placeholder="↻ Search workouts..."
              />
            </div> */}
            <div>
              {meal_data.length > 0 &&
                meal_data[2]?.map((cl_row, index) => (
                  <div key={index}>
                    <div className="mt-10">
                      <h1 className="font-bold">
                        {typeof cl_row === "string"
                          ? category.toUpperCase()
                          : ""}
                      </h1>
                    </div>

                    <div className="mt-2 grid xl:grid-cols-4 md:grid-cols-4 sm:grid-cols-3 grid-cols-2  gap-5 ">
                      {typeof cl_row === "object" &&
                        cl_row.map((wl_row, index) =>
                          wl_row.name === wl_row.name ? (
                            <div
                              className="melasbox cursor-pointer hover:bg-[#ffede0]"
                              onClick={() => {
                                history("/mealdiet/meal-view", {
                                  state: wl_row[0],
                                });
                              }}
                              key={index}
                            >
                              <div>
                                <img
                                  loading="lazy"
                                  src={wl_row[0].thumbnail}
                                  alt={wl_row[0]?.dietTitle?.slice(0, 20)}
                                  className="mealsimg"
                                  height={150}
                                  width={150}
                                />
                              </div>
                              <div className="melalin">
                                <div className="modesutit text-capitalize">
                                  {wl_row[0].dietPreparation} min
                                </div>
                                <div className="tabetsbol text-capitalize text-[10px]">
                                  {wl_row[0]?.dietTitle?.slice(0, 20)}
                                </div>
                                <hr />
                                <div className="fastiweekboxtit">
                                  {wl_row[0].dietServing + " serving"}{" "}
                                </div>
                              </div>
                            </div>
                          ) : (
                            <span key={index}></span>
                          )
                        )}
                    </div>
                  </div>
                ))}
              {meal_data.length === 0 ? <h1>No result found.</h1> : <></>}
            </div>
          </div>
          <div className="flex sm:flex-row flex-col justify-start  lg:justify-center mt-20">
            <div className="w-full">
              <div className="cardbox sm:w-full w-full bg-cover bg-center px-0">
                <div className="mode1">
                  <img
                    className="watchImg"
                    alt="watchImg"
                    src={
                      "https://imgftbv1.fastbetter.com/1723027279051lzjpydaj51.png"
                    }
                  />
                  <div>
                    <p className="cardboxtitle text-base">
                      Healthy life belongs to everyone
                    </p>
                    <p className="text-xs">
                      Get receipe tailored to your needs and preferences.
                    </p>
                    <button
                      className="mt-2 light-orgn-btn rounded-lg text-[11px] text-capitalize mb-2"
                      onClick={() => {
                        history("/mealdiet/custom/create/" + category);
                      }}
                    >
                      Custom Created {category}
                    </button>
                  </div>
                </div>
              </div>

              <div className="fasweekdes">
                <div className="mode1">
                  <div className="tabroe">
                    <div className="modetit text-lg">Recommended</div>
                  </div>
                </div>
              </div>
              <div className="fasweekdes spacetop p-0">
                <div className="nutbotmbox">
                  <div className="nutbotmbox1">
                    <div className="nutbotmbox1tex">
                      <p>carbs</p>
                    </div>
                  </div>
                  <div className="tabroe1">
                    <div className="nutbotmtex mb-2">
                      <p>25</p>
                    </div>
                    <div className="modesutit1">
                      <p className="mt-2">gm</p>
                    </div>
                    <div className="nutbarnotfill">
                      <div className="nutbarfill" />
                    </div>
                  </div>
                </div>
                <div
                  className="nutbotmbox"
                  style={{
                    border: "2px solid rgba(88, 85, 158, 0.30)",
                  }}
                >
                  <div
                    className="nutbotmbox1"
                    style={{
                      background: "rgba(88, 85, 158, 0.10)",
                    }}
                  >
                    <div
                      className="nutbotmbox1tex"
                      style={{ color: "#58559E" }}
                    >
                      <p>proteins</p>
                    </div>
                  </div>
                  <div className="tabroe1">
                    <div className="nutbotmtex mb-2">
                      <p>11.8</p>
                    </div>
                    <div className="modesutit1">
                      <p className="mt-2">gm</p>
                    </div>
                    <div className="nutbarnotfill">
                      <div
                        className="nutbarfill"
                        style={{ background: "#58559E" }}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className="nutbotmbox"
                  style={{
                    border: "2px solid rgba(255, 153, 80, 0.30)",
                  }}
                >
                  <div
                    className="nutbotmbox1"
                    style={{
                      background: "rgba(255, 153, 80, 0.10)",
                    }}
                  >
                    <div
                      className="nutbotmbox1tex"
                      style={{ color: "#FF9950" }}
                    >
                      <p>fats</p>
                    </div>
                  </div>
                  <div className="tabroe1">
                    <div className="nutbotmtex mb-2">
                      <p>22</p>
                    </div>
                    <div className="modesutit1">
                      <p className="mt-2">gm</p>
                    </div>
                    <div className="nutbarnotfill">
                      <div
                        className="nutbarfill"
                        style={{ background: "#FF9950" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainBg>

      <Drawer
        open={isDrawerPopupOpen}
        direction="right"
        lockBackgroundScroll={false}
        className={`manlay !p-5 !pb-10 sm:!w-96 !w-80 !overflow-y-scroll !overflow-x-hidden !rounded-l-3xl !border-none`}
        onClose={() => {
          setDrawerPopupOpen(false);
        }}
      >
        {/* {console.log(mealChoosedData)} */}
        <MealView mealChoosedData={mealChoosedData} />
      </Drawer>
    </>
  );
};
export default MealCategory;
